<h2 mat-dialog-title>{{getDocumentTitle() | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <nc-document-form [fileUploadId]="fileUploadId" [inputId]="inputId" [selectId]="selectId" [selectSearchButtonId]="selectSearchButtonId"
                    [selectClearIconId]="selectClearIconId" [selectSearchTextId]="selectSearchTextId"
                    [formGroup]="data.formGroup" [documentTypes$]="data.documentTypes$"></nc-document-form>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
  <nc-button [id]="cancelButtonId" label="cancel" [mat-dialog-close]="{success: false}"></nc-button>
  <nc-button [id]="saveButtonId" label='save' (click)="submit()"></nc-button>
</mat-dialog-actions>
